export default () => ({
  subscriptions: null,
});
